import { render, staticRenderFns } from "./ElFeaturedPost.vue?vue&type=template&id=3d1501a0"
import script from "./ElFeaturedPost.vue?vue&type=script&lang=js"
export * from "./ElFeaturedPost.vue?vue&type=script&lang=js"
import style0 from "./ElFeaturedPost.vue?vue&type=style&index=0&id=3d1501a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports